import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 20px;
  background: #fff;
  border-radius: 5px;

  .title {
    font-size: 2.5rem;
    margin-bottom: 30px;
    font-weight: bold;
  }

  .description {
    margin-bottom: 20px;
  }

  .buttons {
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 20px;
  }
`;
